export class dutchAmounts {
  RunnersByWager: any;
  Pool: any;
  TotalCost: number;
  MinPayout: number;
  MaxPayout: number;
  AmountAllSelected: number;
  PayoutAll: number;

  constructor(RunnersByWager: any, Pool: any, TotalCost: number) {
    this.RunnersByWager = RunnersByWager;
    this.Pool = Pool;
    this.MinPayout = -1;
    this.MaxPayout = 0;
    this.AmountAllSelected = 0;
    this.PayoutAll = 0;
    this.TotalCost = TotalCost;
  }

  // initBaseParams(matrix: any): void {
  //   this.MinPayout = -1;
  //   this.MaxPayout = 0;
  //   this.AmountAllSelected = 0;

  //   for (let i = 0; i < this.RunnersByWager.length; i++) {
  //     let column;
  //     if (this.RunnersByWager[i].length === 1) {
  //       column = matrix.Rows[0].Columns[this.RunnersByWager[i][0] - 1];
  //     }
  //     else {
  //       column = matrix.Rows[this.RunnersByWager[i][0] - 1].Columns[this.RunnersByWager[i][1] - 1];
  //     }

  //     if (column && typeof column.Total !== 'undefined') {
  //       this.AmountAllSelected += column.Total;
  //     }
  //   }

  //   this.AmountAllSelected = isNaN(this.AmountAllSelected) ? 0 : this.AmountAllSelected;
  // }

  // calcAmountByBaseAmount(totalBaseAmount: number, matrix: any): [string, string][] {
  //   const betAmountArray: [string, string][] = [];
  //   this.TotalCost = 0;

  //   for (let i = 0; i < this.RunnersByWager.length; i++) {
  //     let column;
  //     if (this.RunnersByWager[i].length === 1) {
  //       column = matrix.Rows[0].Columns[this.RunnersByWager[i][0] - 1];
  //     }
  //     else {
  //       column = matrix.Rows[this.RunnersByWager[i][0] - 1].Columns[this.RunnersByWager[i][1] - 1];
  //     }

  //     const betAmount = totalBaseAmount * column.Total / this.AmountAllSelected;
  //     const newBetAmount = betAmount - (((betAmount * 100) % (this.Pool.SingleBetMinimum * 100)) / 100);

  //     let payout = 0;
  //     if (typeof column.Price !== 'undefined') {
  //       payout = newBetAmount * column.Price / matrix.PriceBaseWager;
  //     }

  //     const formattedBetAmount = isNaN(newBetAmount) ? '0.00' : newBetAmount.toFixed(2);
  //     const formattedPayout = isNaN(payout) ? '0.00' : payout.toFixed(2);

  //     if (this.MinPayout === -1 || (payout < this.MinPayout && payout > 0)) {
  //       this.MinPayout = parseFloat(formattedPayout);
  //     }
  //     if (payout > this.MaxPayout) {
  //       this.MaxPayout = parseFloat(formattedPayout);
  //     }

  //     this.PayoutAll += parseFloat(formattedPayout);
  //     this.TotalCost += parseInt(formattedBetAmount);
  //     betAmountArray.push([formattedBetAmount, formattedPayout]);
  //   }
  //   return betAmountArray;
  // }

  // calcAmountByBasePayout(totalPayout: number, matrix: any): Array<[string, string]> {
  //   this.TotalCost = 0;
  //   const betAmountArray: Array<[string, string]> = [];

  //   for (let i = 0; i < this.RunnersByWager.length; i++) {
  //     let column;
  //     if (this.RunnersByWager[i].length === 1) {
  //       column = matrix.Rows[0].Columns[this.RunnersByWager[i][0] - 1];
  //     }
  //     else {
  //       column = matrix.Rows[this.RunnersByWager[i][0] - 1].Columns[this.RunnersByWager[i][1] - 1];
  //     }

  //     let betAmount = Math.round(totalPayout / (column.Price / matrix.PriceBaseWager));
  //     let payout = (betAmount * column.Price) / matrix.PriceBaseWager;

  //     betAmount = !isNaN(betAmount) ? parseFloat(betAmount.toFixed(2)) : 0;
  //     payout = !isNaN(payout) ? parseFloat(payout.toFixed(2)) : 0;

  //     if (this.MinPayout === -1 || payout < this.MinPayout) {
  //       this.MinPayout = payout;
  //     }

  //     if (payout > this.MaxPayout) {
  //       this.MaxPayout = payout;
  //     }

  //     this.PayoutAll += payout;
  //     this.TotalCost += parseInt(betAmount.toString(), 10);
  //     betAmountArray.push([betAmount.toString(), payout.toString()]);
  //   }
  //   return betAmountArray;
  // }

  // calcROI(value: number, ticketTotal?: number): number {
  //   if (ticketTotal !== undefined) {
  //     this.TotalCost = ticketTotal;
  //   }
  //   if (this.TotalCost === undefined) {
  //     this.TotalCost = 0;
  //   }
  //   if (value <= 0) return 0;

  //   return Math.round(((value - this.TotalCost) / this.TotalCost) * 100);
  // }

  initBaseParams(matrix: any): any {
    this.MinPayout = -1;
    this.MaxPayout = 0;
    this.AmountAllSelected = 0;

    for(let i=0; i < this.RunnersByWager.length; i++) {
      let column;
      if (this.RunnersByWager[i].length == 1) {
        column = matrix.Rows[0].Columns[this.RunnersByWager[i][0] - 1];
      }
      else {
        column = matrix.Rows[this.RunnersByWager[i][0] - 1].Columns[this.RunnersByWager[i][1] - 1];
      }

      if((typeof column !== 'undefined') && (typeof column.Total !== 'undefined'))
      {
        this.AmountAllSelected += column.Total;
      }
    }

    this.AmountAllSelected = (!isNaN(this.AmountAllSelected) ? this.AmountAllSelected : 0);
  }

  calcAmountByBaseAmount(totalBaseAmount: number, matrix: any): any {
    const betAmountArray: [string, string][] = [];
    this.TotalCost = 0;

    for(let i=0; i < this.RunnersByWager.length; i++) {
      let column;
      if (this.RunnersByWager[i].length == 1) {
        column = matrix.Rows[0].Columns[this.RunnersByWager[i][0] - 1];
      }
      else {
        column = matrix.Rows[this.RunnersByWager[i][0] - 1].Columns[this.RunnersByWager[i][1] - 1];
      }

      let betAmount = totalBaseAmount * column.Total / this.AmountAllSelected;
      const newBetAmount = betAmount - ((
        (betAmount * 100) % (this.Pool.SingleBetMinimum * 100)
      ) / 100);

      betAmount = newBetAmount;

      let payout = 0;
      if(typeof column.Price !== 'undefined')
      {
        payout = betAmount * column.Price / matrix.PriceBaseWager;
      }

      betAmount = (!isNaN(betAmount) ? betAmount : 0);
      payout = (!isNaN(payout) ? payout : 0);

      if (this.MinPayout === -1 || (payout < this.MinPayout && payout > 0)) {
        this.MinPayout = payout;
      }

      if (payout > this.MaxPayout) {
        this.MaxPayout = payout;
      }

      this.PayoutAll += payout;

      this.TotalCost += parseInt(betAmount.toFixed(2));
      betAmountArray.push([betAmount.toFixed(2), payout.toFixed(2)]);
    }

    return betAmountArray;
  }

  calcAmountByBasePayout(totalPayout: number, matrix: any): any {
    this.TotalCost = 0;
    const betAmountArray: [string, string][] = [];

    for(let i=0;i<this.RunnersByWager.length;i++) {
      let column;
      if (this.RunnersByWager[i].length == 1) {
        column = matrix.Rows[0].Columns[this.RunnersByWager[i][0] - 1];
      }
      else {
        column = matrix.Rows[this.RunnersByWager[i][0] - 1].Columns[this.RunnersByWager[i][1] - 1];
      }

      let betAmount = Math.round(totalPayout / (column.Price / matrix.PriceBaseWager));
      let payout = betAmount * column.Price /  matrix.PriceBaseWager;

      betAmount = (!isNaN(betAmount) ? betAmount : 0);
      payout = (!isNaN(payout) ? payout : 0);

      if (this.MinPayout === -1 || payout < this.MinPayout) {
        this.MinPayout = payout;
      }

      if (payout > this.MaxPayout) {
        this.MaxPayout = payout;
      }

      this.PayoutAll += payout;
      this.TotalCost +=parseInt(betAmount.toFixed(2));
      betAmountArray.push([betAmount.toFixed(2), payout.toFixed(2)]);
    }

    return betAmountArray;
  }

  calcROI(value: number, ticketTotal?: number): any {

    if(typeof ticketTotal !== 'undefined')
    {
      this.TotalCost = ticketTotal;
    }

    if(typeof this.TotalCost === 'undefined')
    {
      this.TotalCost=0;
    }

    if(value <=0 )
      return 0;

    return Math.round(( (value - this.TotalCost)/ this.TotalCost) * 100);
  }

}
